import { useEffect, useState } from 'react';
import { firestore } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';

export interface PartnerRadio {
  id: string;
  name?: string;
  logo?: string;
  link?: string;
}

export const usePartnerRadios = () => {
  const [radios, setRadios] = useState<PartnerRadio[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchRadios = async () => {
      try {
        setLoading(true);
        setError(null);

        // Coleção no Firestore com dados das parcerias (logo + link da emissão online)
        const radiosRef = collection(firestore, 'parcerias');
        const snapshot = await getDocs(radiosRef);

        const radiosData: PartnerRadio[] = snapshot.docs.map((docSnap) => {
          const data = docSnap.data() as any;
          return {
            id: docSnap.id,
            name: data?.name ?? '',
            logo: data?.logo ?? '',
            link: data?.link ?? '',
          };
        });

        // Ordena por nome (se existir), senão fica pelo id
        radiosData.sort((a, b) => (a.name || a.id).localeCompare(b.name || b.id));

        setRadios(radiosData);
      } catch (err: any) {
        setError(err?.message || 'Erro ao carregar rádios/parceiras');
      } finally {
        setLoading(false);
      }
    };

    fetchRadios();
  }, []);

  return { radios, loading, error };
};

